import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './colors.styles';
import { CARD_SURFACE } from './surfaces.styles';

export const globalStyles = makeStyles(theme => ({
	fullHeight: {
		height: '100vh',
	},
	textCenter: {
		textAlign: 'center',
	},
	justifyCenter: {
		textAlign: 'justify',
	},
	textRight: {
		textAlign: 'right',
	},
	textBold: {
		fontWeight: 'bold',
	},
	textBlue: {
		color: COLORS.primary,
	},
	textDanger: {
		color: COLORS.danger,
	},
	textInfo: {
		color: COLORS.secondary,
	},
	textPink: {
		color: COLORS.secondary,
	},
	textWarning: {
		color: COLORS.warning,
	},
	textPrimaryHover: {
		color: COLORS.primaryHover,
	},
	textPinkBold: {
		color: COLORS.secondary,
		fontWeight: 'bold',
	},
	textBlack: {
		color: COLORS.terciary,
	},
	textPending: {
		color: COLORS.pending,
	},
	textWhite: {
		color: '#FFFFFF !important',
	},
	textErrorInputKids: {
		color: '#FFDBCF !important',
	},
	textGreen: {
		color: '#1AAA69 !important',
	},
	textRed: {
		color: '#E62619',
	},
	textGrey: {
		color: '#616161',
	},
	textNeutroPpal: {
		color: '#9E9E9E',
	},
	textNeutro600: {
		color: '#848484',
	},
	textNeutro700: {
		color: '#696969',
	},
	textNeutro800: {
		color: '#5E5E5E',
	},
	textNeutro900: {
		color: '#353535',
	},
	textRead: {
		color: '#1AAA69',
	},
	textNoRead: {
		color: '#AA7200',
	},
	mtNegative4: {
		marginTop: -4,
	},
	m0: {
		margin: '0px !important',
	},
	mt0: {
		marginTop: 0,
	},
	mt2: {
		marginTop: 2,
	},
	mt4: {
		marginTop: 4,
	},
	mt5: {
		marginTop: 5,
	},
	mt6: {
		marginTop: 6,
	},
	mt8: {
		marginTop: '8px !important',
	},
	mt10: {
		marginTop: 10,
	},
	mt16: {
		marginTop: 16,
	},
	mt20: {
		marginTop: 20,
	},
	mt23: {
		marginTop: 23,
	},
	mt24: {
		marginTop: '24px !important',
	},
	mt33: {
		marginTop: 33,
	},
	mt34: {
		marginTop: 34,
	},
	mt37: {
		marginTop: 37,
	},
	mt40: {
		marginTop: 40,
	},
	mt44: {
		marginTop: 44,
	},
	mt48: {
		marginTop: 48,
	},
	mt50: {
		marginTop: 50,
	},
	mt54: {
		marginTop: 54,
	},
	mt72: {
		marginTop: 72,
	},
	mt100: {
		marginTop: 100,
	},
	mt148: {
		marginTop: 148,
	},
	mt152: {
		marginTop: 152,
	},
	mt197: {
		marginTop: 197,
	},
	mb2: {
		marginBottom: 2,
	},
	mb4: {
		marginBottom: 4,
	},
	mb5: {
		marginBottom: 5,
	},
	mb8: {
		marginBottom: 8,
	},
	mb10: {
		marginBottom: 10,
	},
	mb16: {
		marginBottom: 16,
	},
	mb17: {
		marginBottom: 17,
	},
	mb20: {
		marginBottom: 20,
	},
	mb21Medio: {
		marginBottom: 21.5,
	},
	mb32: {
		marginBottom: 32,
	},
	mb40: {
		marginBottom: 40,
	},
	mb60: {
		marginBottom: 60,
	},
	mb100: {
		marginBottom: 100,
	},
	mb15: {
		marginBottom: 15,
	},
	mb24: {
		marginBottom: '24px !important',
	},
	mb25: {
		marginBottom: 25,
	},
	mb30: {
		marginBottom: 30,
	},
	mb36: {
		marginBottom: 36,
	},
	mb80: {
		marginBottom: 78,
	},
	mb278: {
		marginBottom: 278,
	},
	mb260: {
		marginBottom: 260,
	},
	mtb8: {
		margin: '8px 0 !important',
	},
	mtb10: {
		margin: '10px 0',
	},
	mtb16: {
		margin: '16px 0',
	},
	mtb17: {
		margin: '17px 0',
	},
	mtb20: {
		margin: '20px 0 !important',
	},
	mtb24: {
		margin: '24px 0 !important',
	},
	mr3: {
		marginRight: 3,
	},
	mr4: {
		marginRight: 4,
	},
	mr5: {
		marginRight: 5,
	},
	mr0: {
		marginRight: '0 !important',
	},
	mr8: {
		marginRight: '8px !important',
	},
	mr10: {
		marginRight: 10,
	},
	mr16: {
		marginRight: 16,
	},
	mr20: {
		marginRight: 20,
	},
	mr24: {
		marginRight: 24,
	},
	mr30: {
		marginRight: 30,
	},
	ml3: {
		marginLeft: 3,
	},
	mlm19: {
		marginLeft: -19,
	},
	mlm3: {
		marginLeft: -3,
	},
	ml0: {
		marginLeft: 0,
	},
	ml6: {
		marginLeft: 6,
	},
	ml8: {
		marginLeft: 8,
	},
	ml4: {
		marginLeft: 4,
	},
	ml5: {
		marginLeft: 5,
	},
	ml10: {
		marginLeft: 10,
	},
	ml16: {
		marginLeft: 16,
	},
	ml31: {
		marginLeft: 31,
	},
	ml40: {
		marginLeft: 40,
	},
	mlr3: {
		marginLeft: 3,
		marginRight: 3,
	},
	mlr8: {
		marginLeft: 8,
		marginRight: 8,
	},
	mlr16: {
		marginLeft: '16px !important',
		marginRight: '16px !important',
	},
	ml24: {
		marginLeft: 24,
	},
	mlr30: {
		marginLeft: 30,
		marginRight: 30,
	},
	mlrAuto: {
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	mauto: {
		margin: '0 auto',
	},
	border_4: {
		borderRadius: 4,
	},
	border_8: {
		borderRadius: '8px !important',
	},
	border_45: {
		borderRadius: '45px !important',
	},
	bbottom1: {
		borderBottom: '1px solid white',
	},
	bbWhite: {
		border: '2px solid white !important',
	},
	p0: {
		padding: '0px !important',
	},
	p4: {
		padding: 4,
	},
	p8: {
		padding: 8,
	},
	p8I: {
		padding: '8px !important',
	},
	p2: {
		padding: 2,
	},
	p10: {
		padding: 10,
	},
	p12: {
		padding: '12px !important',
	},
	p15: {
		padding: 15,
	},
	p16: {
		padding: 16,
	},
	p22: {
		padding: 22,
	},
	p24: {
		padding: 24,
	},
	p32: {
		padding: 32,
	},
	p48: {
		padding: 48,
	},
	pt2: {
		paddingTop: 2,
	},
	pt4: {
		paddingTop: 4,
	},
	pt8: {
		paddingTop: '8px !important',
	},
	pt9: {
		paddingTop: 9,
	},
	pt12: {
		paddingTop: 12,
	},
	pt10: {
		paddingTop: 10,
	},
	pt15: {
		paddingTop: 15,
	},
	pt16: {
		paddingTop: 16,
	},
	pt18: {
		paddingTop: 18,
	},
	pt22: {
		paddingTop: 22,
	},
	pt23: {
		paddingTop: 23,
	},
	pt24: {
		paddingTop: 24,
	},
	pt25: {
		paddingTop: 25,
	},
	pt28: {
		paddingTop: 28,
	},
	pt29: {
		paddingTop: 29,
	},
	pt36: {
		paddingTop: '36px !important',
	},
	pt34: {
		paddingTop: 34,
	},
	pt40: {
		paddingTop: '40px !important',
	},
	pt42: {
		paddingTop: '42px !important',
	},
	pt58: {
		paddingTop: '58px !important',
	},
	pt60: {
		paddingTop: '60px !important',
	},
	pt68: {
		paddingTop: '68px !important',
	},
	pt71: {
		paddingTop: '71px !important',
	},
	pt80: {
		paddingTop: '80px !important',
	},
	pt116: {
		paddingTop: 116,
	},
	pt132: {
		paddingTop: 132,
	},
	pt152: {
		paddingTop: 152,
	},
	pt197: {
		paddingTop: 197,
	},
	pt216: {
		paddingTop: 216,
	},
	pb0: {
		paddingBottom: '0px !important',
	},
	pb2: {
		paddingBottom: 2,
	},
	pb4: {
		paddingBottom: 4,
	},
	pb7: {
		paddingBottom: '7px !important',
	},
	pb8: {
		paddingBottom: '8px !important',
	},
	pb10: {
		paddingBottom: 10,
	},
	pb15: {
		paddingBottom: 15,
	},
	pb16: {
		paddingBottom: 16,
	},
	pb17: {
		paddingBottom: 17,
	},
	pb18: {
		paddingBottom: 18,
	},
	pb20: {
		paddingBottom: 20,
	},
	pb21: {
		paddingBottom: 21,
	},
	pb23: {
		paddingBottom: 23,
	},
	pb32: {
		paddingBottom: 32,
	},
	pb33: {
		paddingBottom: 33,
	},
	pt32: {
		paddingTop: '32px !important',
	},
	pb22: {
		paddingBottom: 22,
	},
	pb24: {
		paddingBottom: 24,
	},
	pb25: {
		paddingBottom: 25,
	},
	pb27: {
		paddingBottom: 27,
	},
	pb40: {
		paddingBottom: 40,
	},
	pb42: {
		paddingBottom: 42,
	},
	pb50: {
		paddingBottom: 50,
	},
	pb60: {
		paddingBottom: 60,
	},
	pb69: {
		paddingBottom: 69,
	},
	pb76: {
		paddingBottom: 76,
	},
	pb79: {
		paddingBottom: 79,
	},
	pb86: {
		paddingBottom: 86,
	},
	pb133: {
		paddingBottom: '133px !important',
	},
	pb162: {
		paddingBottom: 162,
	},
	pb172: {
		paddingBottom: 172,
	},
	pb214: {
		paddingBottom: 214,
	},
	pr4: {
		paddingRight: 4,
	},
	pr6: {
		paddingRight: 6,
	},
	pr8: {
		paddingRight: '8px !important',
	},
	pr9: {
		paddingRight: 9,
	},
	pr10: {
		paddingRight: 10,
	},
	pr14: {
		paddingRight: 14,
	},
	pr16: {
		paddingRight: 16,
	},
	pr17: {
		paddingRight: 17,
	},
	pr24: {
		paddingRight: 24,
	},
	pr32: {
		paddingRight: 32,
	},
	pr35: {
		paddingRight: 35,
	},
	pr41: {
		paddingRight: 41,
	},
	pr176: {
		paddingRight: 176,
	},
	pl0: {
		paddingLeft: '0px !important',
	},
	pl2: {
		paddingLeft: 2,
	},
	pl4: {
		paddingLeft: 4,
	},
	pl6: {
		paddingLeft: 6,
	},
	pl8: {
		paddingLeft: 8,
	},
	pl10: {
		paddingLeft: 10,
	},
	pl12: {
		paddingLeft: 12,
	},
	pl14: {
		paddingLeft: 14,
	},
	pl16: {
		paddingLeft: 16,
	},
	pl24: {
		paddingLeft: 24,
	},
	pl22: {
		paddingLeft: 22,
	},
	pl28: {
		paddingLeft: 28,
	},
	pl29: {
		paddingLeft: 29,
	},
	pl30: {
		paddingLeft: 30,
	},
	pl35: {
		paddingLeft: 35,
	},
	pl40: {
		paddingLeft: 40,
	},
	pl60: {
		paddingLeft: 60,
	},
	pl72: {
		paddingLeft: 72,
	},
	pl100: {
		paddingLeft: 100,
	},
	pl103: {
		paddingLeft: 103,
	},
	pl119: {
		paddingLeft: 119,
	},
	pl176: {
		paddingLeft: 176,
	},
	plr0: {
		paddingLeft: '0px !important',
		paddingRight: '0px !important',
	},
	plr2: {
		paddingLeft: '2px !important',
		paddingRight: '2px !important',
	},
	plr4: {
		paddingLeft: '4px !important',
		paddingRight: '4px !important',
	},
	plr5: {
		paddingLeft: '5px !important',
		paddingRight: '5px !important',
	},
	plr8: {
		paddingLeft: '8px !important',
		paddingRight: '8px !important',
	},
	plr10: {
		paddingLeft: 10,
		paddingRight: 10,
	},
	plr12: {
		paddingLeft: 12,
		paddingRight: 12,
	},
	plr14: {
		paddingLeft: 14,
		paddingRight: 14,
	},
	plr16: {
		paddingLeft: 16,
		paddingRight: 16,
	},
	plr17: {
		paddingLeft: 17,
		paddingRight: 17,
	},
	plr20: {
		paddingLeft: 20,
		paddingRight: 20,
	},
	plr24: {
		paddingLeft: 24,
		paddingRight: 24,
	},
	plr25: {
		paddingLeft: 25,
		paddingRight: 25,
	},
	plr30: {
		paddingLeft: '30px !important',
		paddingRight: '30px !important',
	},
	plr100: {
		paddingLeft: 100,
		paddingRight: 100,
	},
	p7: {
		padding: 7,
	},
	pt20: {
		paddingTop: 20,
	},
	pt30: {
		paddingTop: 30,
	},
	ptb2: {
		paddingTop: 2,
		paddingBottom: 2,
	},
	ptb4: {
		paddingTop: 4,
		paddingBottom: 4,
	},
	ptb8: {
		paddingTop: 8,
		paddingBottom: 8,
	},
	ptb12: {
		paddingTop: '12px !important',
		paddingBottom: '12px !important',
	},
	ptb15: {
		paddingTop: 15,
		paddingBottom: 15,
	},
	ptb16: {
		paddingTop: 16,
		paddingBottom: 16,
	},
	ptb17: {
		paddingTop: 17,
		paddingBottom: 17,
	},
	ptb24: {
		paddingTop: 24,
		paddingBottom: 24,
	},
	ptb32: {
		paddingTop: 32,
		paddingBottom: 32,
	},
	ptb36: {
		paddingTop: 36,
		paddingBottom: 36,
	},
	ptb40: {
		paddingTop: 40,
		paddingBottom: 40,
	},
	p10pb0: {
		padding: '10px 10px 0px 10px',
	},
	wAuto: {
		width: 'auto !important',
	},
	width100I: {
		width: '100% !important',
	},
	width90I: {
		width: '90% !important',
	},
	widthDialogConfirm: {
		width: 312,
	},
	widthDialogConfirmBrowser: {
		width: 427,
	},
	widthDialog: {
		width: '432px',
	},
	widthDialogSearch: {
		width: '656px',
	},
	widthFitContent: {
		width: 'fit-content',
	},
	w50_upMD: {
		[theme.breakpoints.up('md')]: {
			width: '50%',
		},
	},
	w48: {
		width: '48%',
	},
	w50: {
		width: '50%',
	},
	w60: {
		width: '60%',
	},
	w90: {
		width: '90%',
	},
	w87: {
		width: '87%',
	},
	w80: {
		width: '80%',
	},
	w100: {
		width: '100% !important',
	},
	w192: {
		width: 192,
	},
	w100px: {
		width: '100px !important',
	},
	w120: {
		width: 120,
	},
	w287: {
		width: 287,
	},
	w430: {
		width: 430,
	},
	hAuto: {
		height: 'auto !important',
	},
	h100: {
		height: '100%',
	},
	h800: {
		height: 800,
	},
	maxW100: {
		maxWidth: '100%',
	},
	maxNone: {
		maxWidth: 'none !important',
	},
	maxContent: {
		width: 'max-content !important',
	},
	fitContent: {
		width: 'fit-content !important',
	},
	maxW70: {
		maxWidth: '70%',
	},
	maxW50: {
		maxWidth: '50%',
	},
	fw300: {
		fontWeight: 300,
	},
	fw400: {
		fontWeight: 400,
	},
	fw500: {
		fontWeight: 500,
	},
	fw600: {
		fontWeight: 600,
	},
	fwNormal: {
		fontWeight: 'normal',
	},
	fw700: {
		fontWeight: 700,
	},
	fw800: {
		fontWeight: 800,
	},
	fontSize8: {
		fontSize: 8,
	},
	fontSize9: {
		fontSize: 9,
	},
	fontSize10: {
		fontSize: 10,
	},
	fontSize11: {
		fontSize: 11,
	},
	fontSize12: {
		fontSize: 12,
	},
	fontSize13: {
		fontSize: 13,
	},
	fontSize14: {
		fontSize: 14,
	},
	fontSize14I: {
		fontSize: '14px !important',
	},
	fontSize16: {
		fontSize: 16,
	},
	fontSize17: {
		fontSize: 17,
	},
	fontSize18: {
		fontSize: 18,
	},
	fontSize24: {
		fontSize: 24,
	},
	fontSize32: {
		fontSize: 32,
	},
	fontSize40: {
		fontSize: 40,
	},
	fontSize42: {
		fontSize: 42,
	},
	fontSize43: {
		fontSize: 43,
	},
	fontSize48: {
		fontSize: 48,
	},
	borderBox: {
		boxSizing: 'border-box',
	},
	textLeft: {
		textAlign: 'left',
	},
	textUnderline: {
		textDecoration: 'underline',
	},
	textNoUnderline: {
		textDecoration: 'none',
	},
	textCapitalize: {
		textTransform: 'capitalize',
	},
	textUppercase: {
		textTransform: 'uppercase',
	},
	textLowercase: {
		textTransform: 'lowercase',
	},
	textNoTransform: {
		textTransform: 'none',
	},
	lineHeightNormal: {
		lineHeight: 'normal',
	},
	lineHeight8: {
		lineHeight: '8px',
	},
	lineHeight16: {
		lineHeight: '16px',
	},
	lineHeight18: {
		lineHeight: '18px',
	},
	lineHeight19: {
		lineHeight: '19px',
	},
	lineHeight20: {
		lineHeight: '20px',
	},
	lineHeight22: {
		lineHeight: '22px',
	},
	lineHeight24: {
		lineHeight: '24px',
	},
	lineHeight33: {
		lineHeight: '33px',
	},
	lineHeight40: {
		lineHeight: '40px',
	},
	colorWhite: {
		color: 'white !important',
	},
	colorSemiPurple: {
		color: COLORS.KidColorSemiPurple,
	},
	colorSemiBlack: {
		color: '#363636',
	},
	colorNewSemiBlack: {
		color: COLORS.newSemiBlack,
	},
	colorSemiBold: {
		color: '#3C3C3C',
	},
	colorBlack: {
		color: '#0F0F0F',
	},
	colorBlackI: {
		color: '#0F0F0F !important',
	},
	colorSemiWhite: {
		color: '#FAFAFA',
	},
	colorSemiBrown: {
		color: '#270B02',
	},
	colorSemiWhiteI: {
		color: '#FAFAFA !important',
	},
	colorTextPositive: {
		color: '#1AAA69',
	},
	bgSemiWhite: {
		background: 'rgba(250, 250, 250, 0.5)',
	},
	bgRed: {
		background: COLORS.danger,
	},
	bgNone: {
		background: 'none !important',
	},
	bgGreen: {
		background: 'var(--semantico-exito-color-success-main, #1AAA69) !important',
	},
	bgYellow: {
		background: 'var(--Background-bg-warning-inverted, #F3B524) !important',
	},
	bgOrangeAvatar: {
		background: COLORS.kidColorAvatar,
	},
	bgSemiOrange: {
		background: COLORS.primaryDisable,
	},
	textOverflowDots: {
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
	},
	bgBlue: {
		backgroundColor: COLORS.secondary,
	},
	bgSemiPurple: {
		backgroundColor: COLORS.semiPurple,
	},
	bgPink: {
		backgroundColor: COLORS.primary,
	},
	bgWhite: {
		background: '#fff !important',
	},
	bgGrey: {
		background: '#BEBEBE',
	},
	bgColorTransparent: {
		backgroundColor: 'transparent !important',
	},
	bgColorWhite: {
		backgroundColor: 'white',
	},
	bgColorWhiteBlue: {
		backgroundColor: '#E4EEFB !important',
	},
	bgBlack: {
		background: 'black',
	},
	bgNeutro300: {
		background: '#CFCFCF',
	},
	bgNeutro800: {
		color: '#4F4F4F',
	},
	bgBlur3: {
		backdropFilter: 'blur(3px)',
	},
	bgGradientWhiteBlue: {
		backgroundColor: '#F5F5F5',
	},
	bgGradientWhiteGrey: {
		backgroundColor: '#F5F5F5',
	},
	bgGradientWhiteGreyInvert: {
		backgroundColor: '#F5F5F5',
	},
	bgGradientBlueMarine: {
		background: `${COLORS.primary} !important`,
	},
	bgGradientBlueMarineDisabled: {
		background: `#FDDED3 !important`,
	},
	bgGradientPink: {
		background: `${COLORS.secondary} !important`,
	},
	bgGradientWhitePink: {
		background: `${COLORS.secondary} !important`,
	},
	borderTopMultiColor: {
		borderColor: COLORS.separator,
	},
	borderTopMultiColorThin: {
		borderTop: '1px solid transparent',
		borderColor: COLORS.separator,
	},
	removeGreyBackground: {
		'&> .MuiBackdrop-root': {
			backgroundColor: 'transparent',
		},
	},
	flexJustifyRight: {
		display: 'flex',
		justifyContent: 'right',
	},
	colorPrimary: {
		color: `${COLORS.primary} !important`,
	},
	colorGrey: {
		color: '#8B8B8B',
	},
	colorPink: {
		color: COLORS.secondary,
	},
	errorMessage: {
		color: '#f44336',
		fontSize: 12,
	},
	icon: {
		height: 80,
		width: 80,
		margin: '0 auto',
		marginBottom: 16,
		'&.MuiSvgIcon-root': {
			height: 80,
			width: 80,
			margin: '0 auto',
			marginBottom: 16,
		},
	},
	colorIconSuccess: {
		'&.MuiSvgIcon-root': {
			color: '#00BD1E',
		},
	},
	opacity50: {
		opacity: 0.5,
	},
	noPointerEvents: {
		pointerEvents: 'none',
	},
	cursorPointer: {
		cursor: 'pointer !important',
	},
	displayNone: {
		display: 'none',
	},
	displayContent: {
		display: 'contents',
	},
	flex: {
		display: 'flex',
	},
	nowrap: {
		flexWrap: 'nowrap',
	},
	justifySpaceBetween: {
		justifyContent: 'space-between',
	},
	flexJustifyStart: {
		display: 'flex',
		justifyContent: 'flex-start',
	},
	flexJustifyEnd: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	flexJustifySpaceBetweenAlignEnd: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	flexJustifyCenter: {
		display: 'flex',
		justifyContent: 'center',
	},
	contentCenter: {
		justifyContent: 'center',
	},

	dFlex: {
		display: 'flex',
	},
	flexJustifySpaceBetween: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	flexJustifySpaceAround: {
		display: 'flex',
		justifyContent: 'space-around',
	},
	flexAlignBaseLine: {
		display: 'flex',
		alignItems: 'baseline',
	},
	flexAlignStart: {
		display: 'flex',
		alignItems: 'flex-start',
	},
	flexAlignEnd: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	flexAlignEndImportant: {
		alignItems: 'flex-end !important',
	},
	flexAlignCenter: {
		display: 'flex',
		alignItems: 'center',
	},
	alignItemsCenter: {
		alignItems: 'center',
	},
	alignContentSpaceBetween: {
		alignContent: 'space-between',
	},
	alignContentCenter: {
		alignContent: 'center',
	},
	alignContentEnd: {
		alignContent: 'end',
	},
	alignContentStart: {
		alignContent: 'flex-start',
	},
	flexDirectionColumn: {
		display: 'flex',
		flexDirection: 'column',
	},
	flexDirectionRow: {
		display: 'flex',
		flexDirection: 'row',
	},
	flex1: {
		flex: 1,
	},
	wordBreakAll: {
		wordBreak: 'break-all',
	},
	toolbarnobar: {
		paddingBottom: 12,
	},
	dividerMultiColor: {
		'&.MuiDivider-root': {
			backgroundColor: COLORS.separator,
		},
	},
	dividerMultiColorKids: {
		'&.MuiDivider-root': {
			backgroundColor: '#DAD1F0 !important',
		},
	},
	dividerGrayColor: {
		'&.MuiDivider-root': {
			backgroundColor: '#F5F5F5',
		},
		height: '2px',
	},
	dividerDarkerGrayColor: {
		'&.MuiDivider-root': {
			backgroundColor: '#CFCFCF',
		},
		height: '2px',
	},
	dividerMultiColorh2: {
		'&.MuiDivider-root': {
			backgroundColor: COLORS.separator,
		},
		height: '2px',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center'
	},
	buttonDown: {
		position: 'absolute',
		bottom: 30,
		left: '25%',
	},
	buttonDown1: {
		position: 'absolute',
		bottom: 76,
		left: '25%',
		right: '25%',
	},
	buttonDown2: {
		position: 'absolute',
		bottom: 30,
		left: '25%',
		right: '25%',
	},
	buttonDown3: {
		position: 'absolute',
		bottom: 32,
		transform: 'translateX(50%)',
	},
	buttonDown4: {
		position: 'absolute',
		bottom: 32,
	},
	buttonDown5: {
		position: 'absolute',
		bottom: 32,
		left: '0%',
	},
	buttonDownFlex: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
	},
	buttonDownFlexRow: {
		display: 'flex',
		flexDirection: 'row',
		flex: 1,
	},
	topAuto: {
		marginTop: 'auto',
	},
	positionAbsolute: {
		position: 'absolute',
	},
	buttonPositionDown: {
		[theme.breakpoints.down('md')]: {
			position: 'absolute',
			bottom: 20,
		},
	},
	separator: {
		background: '#CFCFCF',
		height: 2,
		width: '100%',
		marginTop: 12,
		marginBottom: 12,
	},
	fixedHeader: {
		position: 'fixed',
		backgroundColor: '#fff',
	},
	disabledComponent: {
		pointerEvents: 'none',
		opacity: 0.7,
	},
	letterSpacing05: {
		letterSpacing: '0.005rem',
	},
	letterSpacing1: {
		letterSpacing: '0.01rem',
	},
	letterSpacing2: {
		letterSpacing: '0.02rem',
	},
	letterSpacing006: {
		letterSpacing: '0.06px',
	},
	letterSpacing032: {
		letterSpacing: '0.32px',
	},
	numsTabular: {
		fontVariantNumeric: 'lining-nums tabular-nums',
	},
	fontFamilyOpenSans: {
		fontFamily: 'Open-Sans !important',
	},
	selectLang: {
		'& .MuiOutlinedInput-root': {
			background: '#FAFAFA',
			border: '2px solid #CFCFCF',
			boxShadow: 'inset 2px 2px 4px rgba(0, 0, 0, 0.04)',
			fontFamily: 'Open-Sans',
			fontStyle: 'normal',
			fontWeight: 400,
			fontSize: 16,
			lineHeight: '22px',
			letterSpacing: '0.02em',
			color: '#000000 !important',
			minWidth: 112,
			marginRight: 10,
			'& div': {
				color: '#000000 !important',
			},
		},
	},
	selectLangKids: {
		'& .MuiOutlinedInput-root': {
			background:
				'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
			border: '2px solid var(--Border-border-primary, #FFF)',
			boxShadow: 'inset 2px 2px 4px rgba(0, 0, 0, 0.04)',
			fontFamily: 'Open-Sans',
			fontStyle: 'normal',
			fontWeight: 400,
			fontSize: 16,
			lineHeight: '22px',
			letterSpacing: '0.02em',
			color: '#FFFFFF',
			minWidth: 112,
			marginRight: 10,
		},
	},
	inputKey: {
		transform: 'rotate(-45deg)',
	},
	borderNone: {
		border: 'none',
	},
	customScrollX: {
		overflowX: 'auto',
		'&::-webkit-scrollbar': {
			width: 15,
			height: 15,
		},
		'&::-webkit-scrollbar-track': {
			boxShadow: 'inset 0 0 5px grey',
			borderRadius: 10,
		},
		'&::-webkit-scrollbar-thumb': {
			background: '#848484',
			borderRadius: 10,
		},
		'&::-webkit-scrollbar-thumb:hover': {
			background: '#848484',
		},
	},
	bottom0: {
		bottom: 0,
	},
	right0: {
		right: 0,
	},
	left0: {
		left: 0,
	},
	positionRelative: {
		position: 'relative',
	},
	positionFixed: {
		position: 'fixed',
	},
	zindex1: {
		zIndex: 1,
	},
	overFlowAutoX: {
		overflowX: 'auto',
	},
	overFlowAutoXButtonSections: {
		overflowX: 'auto',
		overflowY: 'hidden',
		WebkitOverflowScrolling: 'touch',
		display: 'flex',
		flexWrap: 'nowrap',
		touchAction: 'pan-x',     // 👈 CLAVE
		overscrollBehaviorY: 'contain',
		scrollbarWidth: 'none',  // Firefox
		'&::-webkit-scrollbar': {
		  display: 'none',       // Chrome / Safari
		},
	},
	overFlowXHidden: {
		overflowX: 'hidden',
	},
	overFlowYHidden: {
		overflowY: 'hidden',
	},
	juniorKidsBackRoot: {
		background:
			'var(--BG-Junior, linear-gradient(126deg, #CC3900 0%, #B270D6 97.93%)) !important',
		backgroundAttachment: 'fixed !important',
		minHeight: '100vh !important',
		position: 'relative',
		[theme.breakpoints.down('sm')]: {
				minHeight: '100dvh !important',
		},
	},
	juniorKidsBack: {
		background:
			'var(--BG-Junior, linear-gradient(126deg, #CC3900 0%, #B270D6 97.93%)) !important',
	},
	juniorKidShadow: {
		background:
			'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
	},
	boxStyle: {
		...CARD_SURFACE,
		padding: '16px',
	},
	boxStyleKids: {
		padding: '16px',
		background:
			'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
		boxShadow: '0px 2px 4px 0px rgba(78, 78, 78, 0.19)',
		borderRadius: 8,
	},
	juniorKidsBackPopoverStyle: {
		'& .MuiPaper-root': {
			background:
				'var(--BG-Junior, linear-gradient(126deg, #CC3900 0%, #B270D6 97.93%)) !important',
		},
	},
	lastMovements: {
		...CARD_SURFACE,
		padding: '16px 24px',
	},
	lastMovementsKids: {
		padding: '16px 24px',
		background:
			'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
		boxShadow: '0px 2px 4px 0px rgba(78, 78, 78, 0.19)',
		borderRadius: 8,
	},
	container: {
		...CARD_SURFACE,
		padding: 8,
	},
	containerKids: {
		background:
			'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
		boxShadow: '0px 2px 4px 0px rgba(78, 78, 78, 0.19)',
		borderRadius: 8,
		padding: 8,
	},
	newContainer: {
		...CARD_SURFACE,
		padding: '8px 16px',
	},
	newContainerKids: {
		background:
			'var(--Buttons-Primary-button-primary-bg, rgba(255, 255, 255, 0.10)) !important',
		boxShadow: '0px 2px 4px 0px rgba(78, 78, 78, 0.19)',
		borderRadius: 8,
		padding: '8px 16px',
	},
	dividerColorWhite: {
		'&.MuiDivider-root': {
			backgroundColor: 'white !important',
		},
	},
	iconFillWhite: {
		'& path': {
			fill: 'white !important',
		},
	},
	iconDisabledKidsWhite: {
		'& path': {
			opacity: '0.3 !important',
		},
	},
	iconFillSemiPurple: {
		'& path': {
			fill: COLORS.KidColorSemiPurple,
		},
	},
	iconFillViolet: {
		'& path': {
			fill: COLORS.secondary,
		},
	},
	iconStrokeWhite: {
		'& path': {
			stroke: 'white !important',
		},
	},
	overFlowHidden: {
		overflow: 'hidden',
	},
	breakWord: {
		wordWrap: 'break-word',
	},
	colorAccent: {
		color: COLORS.accent,
	},
	dividerAccentColor: {
		'&.MuiDivider-root': {
			backgroundColor: COLORS.accent,
		},
	},
	minWidth620: {
		minWidth: 620,
	},
	textCapFirstLetter: {
		textTransform: 'none',
	},
	colorKidWhite: {
		color: COLORS.KidWhite,
	},
	colorKidPositive: {
		color: COLORS.KidPositive,
	},
	colorKidDanger: {
		color: COLORS.KidDanger,
	},
	avatarCard: {
		width: '32px !important',
		height: '32px !important',
	},
	avatarCard20: {
		width: '20px !important',
		height: '20px !important',
	},
	inLineFlex: {
		display: 'inline-flex',
	},
	linksDisabled: {
		backgroundColor: 'grey',
		cursor: 'not-allowed',
		opacity: '0.6',
	},
	svgHelpOutline: {
		width: '16px !important',
		height: '16px !important',
	},
	buttonStyle: {
		'& .MuiButton-root': {
			padding: '10px 40px',
		},
	},
	bizumDetailWrapper: {
		gap: 32,
	},
	marginInputs0: {
        '& .MuiFormControl-root': {
            margin: '0px !important'
        }
    },
	bgColorLightGrey: {
		background: COLORS.lightGrey
	},
    pageContainerWithFooter: {
            marginBottom: 'calc(80px + env(safe-area-inset-bottom)) !important',
    },
	minHeight100vh: {
		minHeight: '100vh',
	},
}));
